export default {
  budgetAllocationAndMediaMix: 'Budget Allocation & Media Mix',
  salesDecomposition: '{kpi} Decomposition',
  mediaEffect: 'Media Effect',
  competitionEffect: 'Competition Effect',
  economyAndOthersEffect: 'Economy & Others Effect',
  pricingEffect: 'Pricing Effect',
  distributionEffect: 'Distribution Effect',
  seasonalityAndOutliersEffect: 'Seasonality & Outliers Effect',
  spend: 'Spend'
}
